export default __webpack_public_path__ + "static/media/FINANCIAL.ddd06f27.png";